import { SortDirections } from '@shared/components/sortable-section/models/sortable-section.model';
import {
  InventoryWorksheetCountSortOptions,
  InventoryWorksheetEditSortOptions,
} from '@usf/ngrx-inventory';

export type SortType =
  | InventoryWorksheetCountSortOptions
  | InventoryWorksheetEditSortOptions;

export const SortFields = {
  ...InventoryWorksheetCountSortOptions,
};

export interface SortSelection {
  fieldName: string;
  sortValue: string;
}

export interface SortOption {
  sortName: SortType;
  sortDirection: SortDirections;
  label: string;
}
